import { render, staticRenderFns } from "./FacebookTemplate.vue?vue&type=template&id=48688166&scoped=true&"
import script from "./FacebookTemplate.vue?vue&type=script&lang=ts&"
export * from "./FacebookTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./FacebookTemplate.vue?vue&type=style&index=0&id=48688166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48688166",
  null
  
)

export default component.exports